/* eslint-disable no-param-reassign */
import produce from 'immer';
import { LOGIN_FAILURE, LOGIN_REQUEST, LOGIN_SUCCESS, LOGOUT, SILENT_LOGIN } from 'actions/accountActions';

const initialState = {
  user: null
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST: {
      return produce(state, (draft) => {
        // Ensure we clear current session
        draft.isLogin = false;
        draft.user = null;
      });
    }

    case LOGIN_SUCCESS: {
      const { isLogin, user } = action.payload;

      return produce(state, (draft) => {
        draft.isLogin = isLogin;
        draft.user = user;
      });
    }

    case LOGIN_FAILURE: {
      return produce(state, () => {
        // Maybe store error
      });
    }

    case LOGOUT: {
      return produce(state, (draft) => {
        draft.isLogin = false;
        draft.user = null;
      });
    }

    case SILENT_LOGIN: {
      const { user, isLogin } = action.payload;

      return produce(state, (draft) => {
        draft.isLogin = isLogin;
        draft.user = user;
      });
    }

    default: {
      return state;
    }
  }
};

export default accountReducer;
